import { render, staticRenderFns } from "./material-class-statistics.vue?vue&type=template&id=d9f2dd66&scoped=true"
import script from "./material-class-statistics.ts?vue&type=script&lang=ts&external"
export * from "./material-class-statistics.ts?vue&type=script&lang=ts&external"
import style0 from "./material-class-statistics.scoped.scss?vue&type=style&index=0&id=d9f2dd66&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f2dd66",
  null
  
)

export default component.exports